import React, { Component } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import { TRANSITION_TIMEOUT } from 'common/constants';

const BASE_CLASS_NAME = 'LazyImage';

export default class LazyImage extends Component {
    static propTypes = {
        src: PropTypes.string.isRequired,
        alt: PropTypes.string,
        role: PropTypes.string,
        transitionDuration: PropTypes.string,
        onLoad: PropTypes.func,
        className: PropTypes.string,
    };

    static defaultProps = {
        alt: null,
        role: null,
        transitionDuration: `${TRANSITION_TIMEOUT}ms`,
        onLoad: null,
        className: null,
    };

    state = {
        loaded: false,
    };

    constructor(props) {
        super(props);
        this.image = new Image();
        this.image.src = this.props.src;
        this.image.onload = this.onLoad;
    }

    onLoad = () => {
        this.setState({ loaded: true });
        this.props.onLoad && this.props.onLoad();
    };

    componentWillUnmount() {
        if (this.image) {
            this.image.onload = noop;
        }
    }

    render() {
        const { src, alt, role, transitionDuration, className } = this.props;

        const style = {
            opacity: this.state.loaded ? 1 : 0,
            transition: `opacity ease ${transitionDuration}`,
        };

        return (
            <img className={`${BASE_CLASS_NAME} ${className || ''}`} style={style} src={src} alt={alt} role={role} />
        );
    }
}
